import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { LocalFaturamentoMultiselectModule } from '../../local-faturamento/multiselect';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead';
import { RepresentanteSharedModule } from '../../pessoa/representante';
import { RepresentanteMultiselectModule } from '../../pessoa/representante/multiselect';
import { UsuarioGerenteMultiselectModule, UsuarioAtendenteMultiselectModule } from '../../usuario/multiselect';
import { TituloReceberReferenciaDataSelectModule } from '../referencia-data';
import { TituloReceberSituacaoModule } from '../situacao';
import { ClassificacaoTipoMultiselectModule } from '../../classificacao/tipo/multiselect';

import { TituloReceberFilterComponent } from './titulo-receber-filter.component';
import { TituloReceberVencidosFilterCollapseComponent } from './titulo-receber-vencidos-filter-collapse.component';

@NgModule({
    imports: [
        SharedModule,
        LocalFaturamentoMultiselectModule,
        ClienteTypeaheadSharedModule,
        RepresentanteSharedModule,
        RepresentanteMultiselectModule,
        UsuarioGerenteMultiselectModule,
        UsuarioAtendenteMultiselectModule,
        TituloReceberReferenciaDataSelectModule,
        TituloReceberSituacaoModule,
        ClassificacaoTipoMultiselectModule
    ],
    declarations: [
        TituloReceberFilterComponent,
        TituloReceberVencidosFilterCollapseComponent
    ],
    exports: [
        TituloReceberFilterComponent,
        TituloReceberVencidosFilterCollapseComponent
    ]
})
export class TituloReceberFilterModule { }
